import { FormEvent, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import AppButton from "../../components/form/AppButton";
import AppTextField from "../../components/form/AppTextField";
import { AuthPageShell } from "../../components/layout";
import sessionAuthApi from "../../services/sessionAuth";
import { authEntryButtonSx } from "../login/authEntryButtonSx";

export default function ResetPasswordUI() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const r = await sessionAuthApi.resetPassword(token.trim(), password);
      setMessage(r.message);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <AuthPageShell
      title="Reset password"
      footer={<Link to="/login">Back to login</Link>}
    >
      <Box component="form" onSubmit={onSubmit}>
        <Stack spacing={2}>
          {message && <Alert severity="success">{message}</Alert>}
          {error && <Alert severity="error">{error}</Alert>}
          <AppTextField
            label="Token"
            required
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <AppTextField
            label="New password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <AppButton type="submit" fullWidth variant="contained" sx={{ mt: 1.5, ...authEntryButtonSx }}>
            Update password
          </AppButton>
        </Stack>
      </Box>
    </AuthPageShell>
  );
}
